import Button from "@stadium/checkout/src/components/shared/buttons";
import Pill from "@stadium/ui/src/components/pill";

import styles from "./address.module.scss";

const Address = ({ address, onEditAddress, className = " ", editClassName = "" }) => {
  const {
    firstname,
    lastname,
    phone,
    businessName,
    address1,
    address2,
    city,
    stateNameNonUs,
    countryName,
    zipcode,
    zipcodeNonUs,
    externalId,
    stateAbbreviation,
    default: isDefault,
    isWarehouseAddress,
  } = address;

  const showEditOption = typeof onEditAddress === "function";

  return (
    <>
      <div className={`${styles.labelControl} ${className}`} key={externalId}>
        <div className={styles.labelInfo}>
          <div className={styles.headingInfo}>
            <div className={styles.userName}>
              {firstname} {lastname}
            </div>

            {phone && (
              <div className={styles.userPhone}>
                <i />
                {phone}
              </div>
            )}
            {!isWarehouseAddress && businessName && (
              <div className={styles.companyName}>{businessName}</div>
            )}
          </div>
          <div className={styles.completeAddressContainer}>
            <div className={styles.extraInfo}>
              {[
                address1,
                address2,
                [
                  city,
                  [stateAbbreviation || stateNameNonUs, zipcode || zipcodeNonUs]
                    .filter((s) => s)
                    .join(" "),
                ]
                  .filter((s) => s)
                  .join(", "),
                countryName,
              ]
                .filter((s) => s)
                .map((elmt) => (
                  <div key={elmt}>{elmt}</div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.editAndPreferredContainer} ${editClassName}`}>
        {isDefault && (
          <Pill color="light" className={`${styles.preferredPill} preferred-pill`}>
            Preferred
          </Pill>
        )}
        {showEditOption && (
          <Button
            styleType="link"
            onClick={(event) => {
              onEditAddress(address);
              event.preventDefault();
            }}
            className={styles.editLink}
          >
            Edit
          </Button>
        )}
      </div>
    </>
  );
};

export default Address;
